<template>
  <div class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">Write Cheque </h1>
              <button
                  @click="onClickClose"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>

        <hr class="mt-0 mb-0">

        <div class="pb-2">
          <div class="row mx-2">
            <div class="col-12">
              <label class="form-label">Party<span class="required">*</span></label>
              <AsyncSelect
                  placeholder="Party"
                  v-model="contactProfileId"
                  :api-service="fetchContactProfileDropdownList"
                  :format-label="formatContactProfileLabel"
                  label="name"
                  :reduce="name => name"
              />
            </div>

            <div class="col-12 mt-1">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <label class="form-label mb-0">Vouchers <span class="required">*</span></label>
                <button @click="addLedgerRow" type="button" class="btn btn-outline-primary btn-sm">
                  Add Voucher
                </button>
              </div>
              <div class="table-responsive" style="min-height: 250px; overflow-y: auto; overflow-x: auto;">
                <table class="table table-bordered table-sm" style="min-width: 600px;">
                  <thead>
                    <tr>
                      <th style="width: 60%">Voucher No</th>
                      <th style="width: 30%">Amount</th>
                      <th style="width: 10%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(ledger, index) in selectedLedgers" :key="index">
                      <td>
                        <AsyncSelect
                            :placeholder="'Select Voucher'"
                            v-model="selectedLedgers[index].ledger"
                            :api-service="fetchLedgerMasterList"
                            :additional-query="{
                              contact_profile_id: contactProfileId && contactProfileId.id,
                              exclude_id_in_cheque_register: true,
                              voucher_type: 'payment_voucher,contra_voucher'
                            }"
                            :disabled="!contactProfileId"
                            label="name"
                            :reduce="name => name"
                            @update:modelValue="onLedgerChange(index)"
                        />
                      </td>
                      <td>
                        <input type="number" readonly class="form-control form-control-sm" v-model="selectedLedgers[index].amount" @input="calculateTotalAmount">
                      </td>
                      <td class="text-center">
                        <button @click="removeLedgerRow(index)" type="button" class="btn btn-outline-danger btn-sm">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="col-12 mt-1">
              <label class="form-label">Total Amount <span class="required">*</span></label>
              <input type="text" class="form-control" v-model="formData.amount" readonly>
            </div>

            <div class="col-12">
              <label class="form-label">Date <span class="required">*</span></label>
              <input type="date" class="form-control" v-model="formData.date" >
            </div>

            <div class="col-12 text-center mb-2 mt-2">
              <button :disabled="loading || selectedLedgers.length === 0" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loader"/>

  </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleAccounting from '@/services/modules/accounting'
import handleDropdowns from '@/services/modules/dropdowns'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";

const formData = ref({
  amount:'',
  date:'',
})

const props = defineProps({
  accountHeadId: null,
  selectedItem: null,
})

const emit = defineEmits(['close', 'getData']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const contactProfileId = ref('');
const selectedLedgers = ref([]);
const isEdit = ref(false);
const loader = ref(false);
const isFetching = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');

watch(contactProfileId, () => {
  if (isFetching.value) return;
  selectedLedgers.value = [];
})

const addLedgerRow = () => {
  selectedLedgers.value.push({
    ledger: null,
    amount: 0
  })
}

const removeLedgerRow = (index) => {
  selectedLedgers.value.splice(index, 1)
  calculateTotalAmount()
}

const onLedgerChange = (index) => {
  const ledger = selectedLedgers.value[index].ledger;
  if (!ledger) {
      calculateTotalAmount()
      return;
  }

  const isDuplicate = selectedLedgers.value.some((item, i) => i !== index && item.ledger && item.ledger.id === ledger.id);
  if (isDuplicate) {
    selectedLedgers.value[index].ledger = null;
    selectedLedgers.value[index].amount = 0;
    showError('This voucher is already selected.');
    calculateTotalAmount();
    return;
  }

  if (ledger.total_amount) {
    selectedLedgers.value[index].amount = ledger.total_amount;
  }
  calculateTotalAmount()
}

const calculateTotalAmount = () => {
  formData.value.amount = selectedLedgers.value.reduce((total, item) => total + parseFloat(item.amount || 0), 0).toFixed(2);
}

const { updateChequeRegister, fetchSingleChequeRegister } = handleAccounting();
const { fetchContactProfileDropdownList, fetchLedgerMasterList } = handleDropdowns()
const { formatContactProfileLabel } = useAsyncDropdownHelper()

const submit = async() => {
  const query = getQuery();
  loading.value = true;
  await storeData(query)
}

const storeData = async (query) => {
  let chequeData = {};
  chequeData.amount = formData.value.amount;
  chequeData.date = formData.value.date;
  chequeData.ledgers = selectedLedgers.value.map(item => ({
    ledger_master_id: item.ledger ? item.ledger.id : null,
    amount: item.amount
  })).filter(item => item.ledger_master_id !== null);
  
  chequeData.contact_profile_id = contactProfileId.value ? contactProfileId.value.id : null;
  chequeData.account_head_id = props.accountHeadId;

  await updateChequeRegister(chequeData, props.selectedItem.id, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit('getData')
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickClose = () => {
  emit('close')
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

const fetchData = async () => {
    loader.value = true;
    isFetching.value = true;
    const query = getQuery();
    await fetchSingleChequeRegister(props.selectedItem.id, query).then(res => {
        if (! res.status) {
          return
        }

        const data = res.data;

        if (data.contact_profile_id){
          contactProfileId.value = {
            id: data.contact_profile_id,
            name: data.contact_profile_name
          };
        }

        if (data.generals && data.generals.length > 0) {
          selectedLedgers.value = data.generals.map(gen => ({
            ledger: {
              id: gen.ledger_master_id,
              name: gen.voucher_no + '(' + gen.voucher_type + ')'
            },
            amount: gen.amount
          }));
        }

        if ((!data.generals || data.generals.length === 0) && data.ledger_master_id) {
          selectedLedgers.value = [{
            ledger: {
              id: data.ledger_master_id,
              name: data.voucher_no_type
            },
            amount: data.amount
          }];
        }

        formData.value.amount = data.amount;
        formData.value.date = data.cheque_date || new Date().toISOString().split('T')[0];
    }).finally(() => {
        loader.value = false;
        isFetching.value = false;
    });
}

onMounted(() => {
  formData.value.date = new Date().toISOString().split('T')[0];
  if (props.selectedItem) {
      fetchData();
  }
})

</script>
